// extracted by mini-css-extract-plugin
export var orange = "Spacer-module--orange--f3f5d";
export var root = "Spacer-module--root--b31d3";
export var x2 = "Spacer-module--x2--e3fe1";
export var x3 = "Spacer-module--x3--2b4b6";